import React from 'react';
import { useTranslation } from 'react-i18next';
import { stockLevel } from '../utils/format';

interface Props {
  available: number;
  total?: number;
  className?: string;
}

const STYLES = {
  in: 'bg-green-100 text-green-800',
  low: 'bg-orange-100 text-orange-800',
  out: 'bg-gray-200 text-gray-700',
};

const StockBadge: React.FC<Props> = ({ available, total, className = '' }) => {
  const { t } = useTranslation();
  const level = stockLevel(available);
  const label =
    level === 'out' ? t('inventory.outOfStock') : level === 'low' ? t('inventory.lowStock') : t('inventory.inStock');
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${STYLES[level]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${level === 'out' ? 'bg-gray-500' : level === 'low' ? 'bg-orange-500' : 'bg-green-500'}`} />
      {label}
      {typeof total === 'number' && (
        <span className="opacity-75">
          · {available}/{total}
        </span>
      )}
    </span>
  );
};

export default StockBadge;
